import idlImport from './game2048.did.js';
export const idlFactory = idlImport;
export const canisterId = "maofa-3qaaa-aaaah-aacya-cai";
